import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _DASHBOARD_FEE_RECEIVED_AMOUNT = async (searchData = false) => {
  let url = ServiceUrl.MOB.DASHBOARD_FEE_RECEIVED_AMOUNT;
  return callApi(url, "post", searchData && searchData);
};
